import { useLanguage } from '@/context/LanguageContext';

export function LogoMark({ className = 'h-9 w-9' }) {
  return (
    <svg viewBox="0 0 64 64" className={className} data-testid="logo-mark" aria-hidden="true">
      <defs>
        <linearGradient id="wiyak-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0EA5E9" />
          <stop offset="1" stopColor="#0052FF" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#wiyak-g)" />
      <path d="M14 21a25 25 0 0 1 36 0" stroke="#BFE0FF" strokeWidth="3.5" fill="none" strokeLinecap="round" opacity="0.9" />
      <path d="M20 27a17 17 0 0 1 24 0" stroke="#EAF4FF" strokeWidth="3.5" fill="none" strokeLinecap="round" />
      <path d="M32 26c5 0 9 4 9 9 0 6.5-9 15-9 15s-9-8.5-9-15c0-5 4-9 9-9z" fill="#fff" />
      <circle cx="32" cy="35" r="4" fill="#0052FF" />
    </svg>
  );
}

export default function Logo({ light = false, className = '' }) {
  const { t } = useLanguage();
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img src={t('settings.logo')} alt="WiyakGPS logo" className="h-9 w-9 rounded-full shadow ring-2 ring-white/70" data-testid="logo-mark" />
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? 'text-white' : 'text-brand-ink'}`}>
        Wiyak<span className="text-brand-sky">GPS</span>
      </span>
    </span>
  );
}
